import React from "react";
import { Link } from "react-router-dom";

import styles from "./AuthorWorkBook.module.css";
import { Cover } from "../../Cover/Cover";

import Clamp from "react-multiline-clamp";

export const AuthorWorkBook = (props) => {

    // props:
    //
    // mediaItem - object containing book information
    // ----------------------------------------------------- STATE AND HOOKS

    const splitTitle = processTitle();

    let formattedFullDescripton = formatDescription();

    const seriesPath = "/series/" + props.mediaItem.series?.seriesID;

    // ----------------------------------------------------- PRE-RENDER

    const bookPath = `/${props.mediaItem.type}/` + props.mediaItem.mediaid;

    function formatDescription() {
        // formats description to add new lines
        if (props.mediaItem.description === null) return;

        let formattedDescripton = []
        let descriptionPeices = props.mediaItem.description.split('\n'); //splits description string by newlines
        if (descriptionPeices.length === 1) { //no new lines
            return props.mediaItem.description;
        } else {
            for (let i = 0; i < descriptionPeices.length; i++) {
                if (!descriptionPeices[i]) { //if empty it means there was a blank line
                    formattedDescripton.push(<div key={i} className={styles.spacer}></div>)
                } else {
                    formattedDescripton.push(<div key={i}>{descriptionPeices[i]}</div>) //adds string segment to array
                }
            }
            return (formattedDescripton);
        }
    }

    function processTitle() {
        // splits title into two peices and adds star to second to prevent weird line wrapping
        let words = props.mediaItem.title.split(" ");
        let lastWord = words.pop();

        const firstWords = words.join(" ") + " "

        return [firstWords, lastWord];
    }

    // ----------------------------------------------------- RENDER
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <Cover mediaItem={props.mediaItem} size={window.screen.width > 500 ? "L" : "M"} loc="authorBook" />
                <div className={styles.bookInfo}>
                    <Link to={bookPath} className={styles.link}>
                        <div>
                            <span className={styles.firstWordsOfTitle}>{splitTitle[0]}</span>
                            <span className={styles.lastWordOfTitle}>{splitTitle[1]} {props.mediaItem.favorited ? <img key="star" className={styles.starIconFilled} alt="Favorite star" /> : null}</span>
                        </div>
                    </Link>
                    {props.mediaItem.series != null ?
                        <div>
                            <Link to={seriesPath} className={styles.link}><h3 className={styles.bookSeries}>{props.mediaItem.series?.name} #{props.mediaItem.seriesNum}</h3></Link>
                        </div>
                        :
                        null
                    }
                    <Clamp lines={4}
                        maxLines={100}
                        withTooltip={false}
                        withToggle={true}
                        showMoreElement={({ toggle }) => (
                            <button className={styles.readMoreOrLessButton}
                                onClick={toggle} >
                                <img className={styles.carrot} src="/assets/images/downCarrot.svg" alt="read more" />
                            </button>
                        )}
                        showLessElement={({ toggle }) => (
                            <button className={styles.readMoreOrLessButton}
                                onClick={toggle} >
                                <img className={styles.carrot} src="/assets/images/upCarrot.svg" alt="read less" />
                            </button>
                        )}>
                        <div className={styles.description}>{formattedFullDescripton} </div>
                    </Clamp>
                </div>
            </div>
        </div>
    )
}